var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.27778H4.25C3.91848 6.27778 3.60054 6.40655 3.36612 6.63576C3.1317 6.86497 3 7.17585 3 7.5V11.7778C3 12.1019 3.1317 12.4128 3.36612 12.642C3.60054 12.8712 3.91848 13 4.25 13H11.75C12.0815 13 12.3995 12.8712 12.6339 12.642C12.8683 12.4128 13 12.1019 13 11.7778V7.5C13 7.17585 12.8683 6.86497 12.6339 6.63576C12.3995 6.40655 12.0815 6.27778 11.75 6.27778H10.5M5.5 6.27778V4.44444C5.5 3.79614 5.76339 3.17438 6.23223 2.71596C6.70107 2.25754 7.33696 2 8 2C8.66304 2 9.29893 2.25754 9.76777 2.71596C10.2366 3.17438 10.5 3.79614 10.5 4.44444V6.27778M5.5 6.27778H10.5M8 8.72222V10.5556",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.dcef8d5da3cc9d015128c9983b21b962.svg";
export { ForwardRef as ReactComponent };